/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { accountTypeGetResponseSchema } from './accountTypeGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getAccountType200Schema = z.lazy(() => accountTypeGetResponseSchema);

/**
 * @description 505 response
 */
export const getAccountType505Schema = z.any();

export const getAccountTypeQueryResponseSchema = z.lazy(() => getAccountType200Schema);
